/* List of color palettes for indicator map layers */
var strokeColors = [ 
    '#00454A', '#294C6E', '#28380C', '#2F4034', '#282D33', '#202429'
];

var shapeStyles = [
/* map layer color palette 0 */
[
   '#CCCCCC', '#D6EDEF', '#7AC6CC', '#1C747E', '#424B54', 'rgba(55, 255, 55, 1.0)', 'rgba(0, 0, 0, 0.0)'
],
/* map layer color palette 1 */
[
    '#CCCCCC', '#00939D', '#7AC6CC', '#FF9D54', '#FF6B35', 'rgba(55, 255, 55, 1.0)', 'rgba(0, 0, 0, 0.0)'
],
/* map layer color palette 2 */
[
    '#CCCCCC', '#FF6B35', '#FF9D54', '#FFD275', '#8BB587', 'rgba(55, 255, 55, 1.0)', 'rgba(0, 0, 0, 0.0)'
],
/* map layer color palette 3 */
[
  '#CCCCCC', '#FFD275', '#8BB587', '#1C747E',  '#424B54', 'rgba(55, 255, 55, 1.0)', 'rgba(0, 0, 0, 0.0)'
],
/* map layer color palette 4 */
[
  '#CCCCCC', '#FFD275', '#FF9D54', '#FF6B35',  '#AA5D43', 'rgba(55, 255, 55, 1.0)', 'rgba(0, 0, 0, 0.0)'
],
/* map layer color palette 5 */
[
  '#CCCCCC', '#FFD275', '#B4B74E', '#5B7343', '#424B54', 'rgba(55, 255, 55, 1.0)', 'rgba(0, 0, 0, 0.0)'
],

[
  '#CCCCCC', '#424B54', '#1C747E', '#00939D', '#AA5D43', '#B19D6E', '#8BB587', '#FF6B35', '#FF9D54', '#FFD275'
]];

export default shapeStyles


// WEBPACK FOOTER //
// ./src/modules/mapboxgl/shapeStyles.js